import React, { useState, useEffect, useCallback } from 'react';
import '../css/WorkshopsPage.css';

/**
 * WorkshopSection – reusable component for a single workshop card.
 *
 * Props:
 *  title    {string}   – section heading
 *  items    {string[]} – bullet-point service list
 *  images   {string[]} – array of image paths from /public
 *  reverse  {bool}     – if true, gallery appears above the title+list
 */
const WorkshopSection = ({ title, items, images = [], reverse = false, ...props }) => {
  const [current, setCurrent] = useState(0);

  const prev = useCallback(() =>
    setCurrent(c => (c - 1 + images.length) % images.length), [images.length]);

  const next = useCallback(() =>
    setCurrent(c => (c + 1) % images.length), [images.length]);

  /* Auto-advance every 3 s */
  useEffect(() => {
    if (images.length < 2) return;
    const t = setInterval(next, 3000);
    return () => clearInterval(t);
  }, [next, images.length]);

  const Gallery = images.length > 0 ? (
    <div className="workshop-gallery">
      <img src={images[current]} alt={title} loading="lazy" />
      {images.length > 1 && (
        <>
          <button className="wg-nav prev" onClick={prev} aria-label="Previous">&#8249;</button>
          <button className="wg-nav next" onClick={next} aria-label="Next">&#8250;</button>
          <div className="wg-dots">
            {images.map((_, i) => (
              <button
                key={i}
                className={`wg-dot ${i === current ? 'active' : ''}`}
                onClick={() => setCurrent(i)}
                aria-label={`Slide ${i + 1}`}
              />
            ))}
          </div>
        </>
      )}
    </div>
  ) : null;

  const Info = (
    <>
      <h4 className="workshop-section-title">{title}</h4>
      <ul className="workshop-service-list">
        {items.map((item, i) => <li key={i}>{item}</li>)}
      </ul>
    </>
  );

  return (
    <div className="workshop-col" {...props}>
      {reverse ? (
        <>
          {Gallery}
          {Info}
        </>
      ) : (
        <>
          {Info}
          {Gallery}
        </>
      )}
    </div>
  );
};

export default WorkshopSection;
